import React from 'react';
import { Trip } from '@/types';
import TripDashboardSection from '../TripDashboardSection';
import PendingSignUps from '@/components/signup/PendingSignUps';
import { useI18n } from '@/hooks/useI18n';

interface TripPendingSignUpsPageProps {
  trip: Trip;
}

const TripPendingSignUpsPage: React.FC<TripPendingSignUpsPageProps> = ({ trip }) => {
  const { t } = useI18n();
  
  return (
    <TripDashboardSection
      icon="📝"
      title={t('trip.pages.signUps.title')}
      subtitle={t('trip.pages.signUps.subtitle')}
      description={t('trip.pages.signUps.description')}
    >
      <PendingSignUps trip={trip} />
    </TripDashboardSection>
  );
};

export default TripPendingSignUpsPage;
